import PropTypes from 'prop-types'
import React from 'react'
import cn from 'utils/tailwind/cn'

import Spinner from '../components/Spinner'

function PrimaryButton({
  onClick,
  disabled,
  children,
  loading,
  danger,
  className,
  dataCy,
}) {

  const colorStyles = {
    'bg-red-600 hover:bg-red-500 focus:border-red-700 focus:shadow-outline-red active:bg-red-700 disabled:bg-red-600/50': danger,
    'bg-blue-600 hover:bg-blue-500 focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 disabled:bg-blue-600/50': !danger,
  }

  return (
    <button
      className={cn('inline-flex items-center justify-center py-2 px-6 border border-transparent text-base leading-6 font-medium rounded-md text-white focus:outline-none transition duration-150 ease-in-out', colorStyles, className)}
      data-cy={dataCy}
      disabled={disabled}
      onClick={onClick}
    >
      {loading && <Spinner className="mr-2" />}
      {children}
    </button>
  )
}

PrimaryButton.defaultProps = {
  onClick: () => {},
  disabled: false,
}

PrimaryButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default React.memo(PrimaryButton)
